// extracted by mini-css-extract-plugin
export default {"wrapper":"TJ38SaJtKyYM8P7BZCxf","row":"FgGBFcKP6KDxksD1PIEb","nextBtn":"r7SejgW_CmilX_dLHjG3"};